import React from 'react';

class MapModal extends React.Component {

    componentDidMount() {
        $('.scrollbar-inner').scrollbar({
            ignoreOverlay: false,
            ignoreMobile: false
        });
    }

    render() {
        let {
            featured_image,
            title,
            excerpt,
            permalink,
            id
        } = this.props.location;

        return (
            <div className="card map-location-modal shadow">
                <span className="bg-white circle-icon modal-close-btn" onClick={() => this.props.updateSelection(null)}><i className="fas fa-times"></i></span>
                {
                    featured_image ?
                        <img src={featured_image} alt={title} className="card-img-top"/>
                        : null
                }
                <div className="card-body">
                    <div className="scrollbar-inner">
                        <h2 className="card-title text-uppercase font-weight-bold h6">
                            <a href={permalink} className="text-decoration-none">
                                { title }
                            </a>
                        </h2>
                        <p className="card-text text-black-50 small text-justify">{ excerpt }</p>
                    </div>
                </div>
            </div>
        )
    }
}


export default MapModal;
